export * from '@primeuix/themes/material/toggleswitch';
export { default } from '@primeuix/themes/material/toggleswitch';
